import { fromJS } from 'immutable';
const action = name => `/master/${name}`;

//get all theme category
export const GET_THEME_DATA = action('GET_THEME_DATA');
export const GET_THEME_DATA_SUCCESS = action('GET_THEME_DATA_SUCCESS');
export const GET_THEME_DATA_ERROR = action('GET_THEME_DATA_ERROR');

export const getThemeData = data => ({ type: GET_THEME_DATA, data });
export const getThemeDataSuccess = data => ({ type: GET_THEME_DATA_SUCCESS, data });
export const getThemeDataError = data => ({ type: GET_THEME_DATA_ERROR, data });


//get all theme category
export const GET_WIDGET_MST_DATA = action('GET_WIDGET_MST_DATA');
export const GET_WIDGET_MST_DATA_SUCCESS = action('GET_WIDGET_MST_DATA_SUCCESS');
export const GET_WIDGET_MST_DATA_ERROR = action('GET_WIDGET_MST_DATA_ERROR');

export const getWidgetMstData = data => ({ type: GET_WIDGET_MST_DATA, data });
export const getWidgetMstDataSuccess = data => ({ type: GET_WIDGET_MST_DATA_SUCCESS, data });
export const getWidgetMstDataError = data => ({ type: GET_WIDGET_MST_DATA_ERROR, data });


const initialState = fromJS({

});

const master = (state = initialState, action) => {
  switch (action.type) {
    //get all theme category
    case GET_THEME_DATA_SUCCESS:
      return state.set('themeData', action.data);
    case GET_THEME_DATA_ERROR:
      return state = action.data;

    //get all theme category
    case GET_WIDGET_MST_DATA_SUCCESS:
      return state.set('widgetMst', action.data);
    case GET_WIDGET_MST_DATA_ERROR:
      return state = action.data;

    default:
      return state;
  }
};

export default master;


// WEBPACK FOOTER //
// ./src/ducks/master.js